/**
 * Enum for the native Ad user flight
 */
var NativeAdUserFlight;
(function (NativeAdUserFlight) {
    NativeAdUserFlight[NativeAdUserFlight["NoNativeAd"] = 0] = "NoNativeAd";
    NativeAdUserFlight[NativeAdUserFlight["BingOneClickAllInbox"] = 1] = "BingOneClickAllInbox";
    NativeAdUserFlight[NativeAdUserFlight["BingTwoClickAllInbox"] = 2] = "BingTwoClickAllInbox";
    NativeAdUserFlight[NativeAdUserFlight["BingOneClickOtherOnly"] = 3] = "BingOneClickOtherOnly";
    NativeAdUserFlight[NativeAdUserFlight["BingTwoClickOtherOnly"] = 4] = "BingTwoClickOtherOnly";
    NativeAdUserFlight[NativeAdUserFlight["PrebidOneClickAllInbox"] = 5] = "PrebidOneClickAllInbox";
    NativeAdUserFlight[NativeAdUserFlight["PrebidOneClickOtherOnly"] = 6] = "PrebidOneClickOtherOnly";
    NativeAdUserFlight[NativeAdUserFlight["AppNexusOneClickAllInbox"] = 7] = "AppNexusOneClickAllInbox";
    NativeAdUserFlight[NativeAdUserFlight["AppNexusOneClickOtherOnly"] = 8] = "AppNexusOneClickOtherOnly";
    NativeAdUserFlight[NativeAdUserFlight["AppNexusTwoClickAllInbox"] = 9] = "AppNexusTwoClickAllInbox";
    NativeAdUserFlight[NativeAdUserFlight["AppNexusTwoClickOtherOnly"] = 10] = "AppNexusTwoClickOtherOnly";
})(NativeAdUserFlight || (NativeAdUserFlight = {}));
export default NativeAdUserFlight;
//# sourceMappingURL=NativeAdUserFlight.js.map